<script>
export default {
    name: "ProformaInvoicePrint",

    data() {

        return {
            invoice: {},
            insuranceDetails: {},
            items: {
                invoiceItems:[],
                insurances:[]
            },
            patient: {},
            patientInsurances: [],
            organizations: [],
            footerMessage: {},
        };
    },

    computed: {

        totalProforma() {
            if(!this.items.invoiceItems.length) return 0;

            return this.items.invoiceItems.map(item => parseFloat(item.grandTotal)).reduce((amt,sum) => amt+sum);
        }, 
        showinsurances() {
            if(!this.items.invoiceItems.length) return 0;
            if(this.items.invoiceItemDetails[0].lessNHIF>0||this.items.invoiceItemDetails[0].lessCopay>0) return 1;
            else return 0;
  
        },

        totalDiscount() {
            if(!this.items.invoiceItems.length) return 0;

            return this.items.invoiceItems.map(item => item.discount ? parseFloat(item.discount) : 0)
                .reduce((amt,sum) => amt+sum);
        },

        totalTax() {
            if(!this.items.invoiceItems.length) return 0;

            return this.items.invoiceItems.map(item => item.tax ? parseFloat(item.tax) : 0)
                .reduce((amt, sum) => amt+sum);
        },

        mainInsuranceTotal() {

            const items = this.items.invoiceItems.filter(item => 
                    !parseInt(this.$route.query.organization) || 
                        item.insuranceID == this.$route.query.organization)
                .map(item => parseFloat(item.grandTotal));

            if(!items.invoiceItems.length) return 0;

            return items.invoiceItems.reduce((amt, sum) => sum + amt);
        },

        noInsuranceTotal() {

            if(!this.items.invoiceItems.length) return 0;

            let noInsurances = this.items.invoiceItems.filter(item => !item.insuranceID);

            if(!noInsurances.length) return 0;

            return noInsurances.map(item => parseFloat(item.grandTotal))
                .reduce((amt,sum) => amt+sum);

                
        },

        otherInsuranceTotal() {
            if(!parseInt(this.$route.query.organization)) return 0;

            const items = this.items.invoiceItems.filter(item => 
                        this.otherInsurances.map(org => org.organizationID).includes(item.insuranceID)
                    ).map(item => parseFloat(item.grandTotal));

            if(!items.invoiceItems.length) return 0;

            return items.invoiceItems.reduce((amt, sum) => sum + amt);
        },

        insurances() {
            if(!this.items.invoiceItems.length) return [];

            const insurances = this.items.invoiceItems.map(item => item.insuranceID);

            return this.organizations.filter(org => insurances.includes(org.organizationID));
        },

        otherInsurances() {
            if(!this.items.invoiceItems.length) return [];

            if(!parseInt(this.$route.query.organization)) return [];

            const insurances = this.items.invoiceItems.filter(item => item.insuranceID != this.$route.query.organization)
                .map(item => item.insuranceID);

            return this.organizations.filter(org => insurances.includes(org.organizationID));
        },

        otherInsuranceDetails() {

 const items = this.items.invoiceItems.filter(item => item.insuranceID == this.$route.query.organization);

           // return items.invoiceItems.length ? items.invoiceItems[0] : {};
         return items;
        },

        principalDetails() {
            if(!this.$route.query.organization) return {};

            const orgs = this.organizations.filter(org => 
                    org.organizationID == this.$route.query.organization);

            return orgs.length ? orgs[0] : {};
        },
selectedInsuranceTotal() {

            const itemssel = this.items.invoiceItems.filter(item =>  item.insuranceID == this.$route.query.organization)
                .map(item => parseFloat(item.grandTotal));
  
return itemssel.reduce((amt, sum) => sum + amt,0);
        },
        totalsPerInsurance() {

            // return this.organizations.map(org => {
            //     return {
            //         organization: org.organization,
            //         total: this.items.invoiceItems.filter(item => org.organizationID == item.insuranceID)
            //                         .map(item => parseFloat(item.grandTotal))
            //                         .reduce((sum, itemAmt) => sum+itemAmt),
            //     };
            // });
             return this.items.insurances.map(org => {
                return {
                   // organization: org.organization,
                    organization: org.insurance,
                    total: this.items.invoiceItems.filter(item => item.insuranceID==org.insuranceID )
                                    .map(item => parseFloat(item.grandTotal))
                                    .reduce((sum, itemAmt) => sum+itemAmt),
                    // total: 0,
                };
            });
        },

        insurancesTotal() {

        //    var dsd= this.totalsPerInsurance.map(insurance => insurance.total)
        //             .reduce((sum, total) => sum+total);
        //              return dsd;
       var  total=  this.items.invoiceItems.map(item => parseFloat(item.grandTotal))
                                    .reduce((sum, itemAmt) => sum+itemAmt);
return total;
        },
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ 
                this.fetchInvoiceItems(), this.fetchInsuranceDetails(), this.fetchPatientDetails(), 
                this.fetchInsuranceForUse(), this.fetchOrganizations(), this.fetchMessage(),
            ]).then(() => {
                this.$root.loading = false;
                setTimeout(() => {
                    window.print();
                }, 250);
        }).catch(() => {this.$root.loading = false;});
    },

    methods: {

        fetchInsuranceForUse() {
            let url = `PatientRegistration/GetPatientInsurances`;
                url += `?CustomerID=${this.$route.query.patient}`;

            return this.$http.get(url).then(({data}) => {
                this.patientInsurances = data;
            }).catch(() => {});
        },

        fetchInvoiceItems() {
            let url = `Accounts/GetPatientProformaInvoiceDetailItems`;
                url += `?InvoiceNo=${this.$route.query.invoiceNo}`;

            return this.$http.get(url).then(({data}) => {
                    this.items = data;
                }).catch(() => {});
        },

        fetchInsuranceDetails() {
            if(!parseInt(this.$route.query.organization)) return Promise.reject();

            let url = `MasterData/GetSpecificOrganization`;
                url += `?OrganizationId=${this.$route.query.organization}`;

            return this.$http.get(url).then(({data}) => {
                    this.insuranceDetails = data.length ? data[0] : {};
                }).catch(() => {});
        },

        fetchPatientDetails() {
            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.query.patient}`;

            return this.$http.get(url).then(({data}) => {
                this.patient = data.length ? data[0] : {};
            }).catch(() => {});
        },

        fetchOrganizations() {
            let url = `PatientRegistration/GetPatientInsurances`;
                url += `?CustomerID=${this.$route.query.patient}`;

            return this.$http.get(url).then(({data}) => {
                    this.organizations = data;
                }).catch(() => {});
        },

        fetchMessage() {
            let url = `MasterData/GetSpecificOrganizationMessageforGroup`;
                url += `?Group=Proforma`;
            return this.$http.get(url).then(({data}) => {
                this.footerMessage = data.length ? data[0] : {};
            })
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap items-center">
        <tail-address-header></tail-address-header>
        <div class="w-full flex flex-row p-2 bg-gray-300 mt-2">
            <div class="flex-1 p-tiny">
                <h5 class="font-bold text-sm uppercase">Date: {{ items.invoiceItems.length && items.invoiceItems[0].date | dateFormat}}</h5> 
            </div>
            <div class="flex-1 p-tiny">
                <h5 class="font-bold text-sm uppercase">Proforma Invoice No: {{$route.query.invoiceNo}}</h5>
            </div>
        </div>
        <div class="w-full flex flex-wrap content-start">
                <div class="flex-1">
                    <div class="w-full flex flex-col content-start">
                        <div class="flex-1 p-1">
                            <h5 class="font-bold text-sm uppercase">Invoice To</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">{{insuranceDetails.organization || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Address: {{insuranceDetails.postalAddress || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Contact: {{insuranceDetails.cellphone || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Scheme: {{otherInsuranceDetails.scheme || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Package: {{otherInsuranceDetails.package || `-`}}</h5>
                        </div>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="w-full flex flex-col content-start p-1">
                        <div class="flex-1 p-1">
                            <h5 class="font-bold text-sm uppercase">Bill Details</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm capitalize">Name: {{patient.names}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">MRN:{{patient.patienT_ID}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">OP: {{patient.opfileno || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">IP: {{patient.ipfileno || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">DOB: {{patient.dob | dateFormat}}</h5>
                        </div>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="w-full flex flex-col content-start p-1">
                        <div class="flex-1 p-1">
                            <h5 class="font-bold text-sm uppercase">Principal Details</h5>
                        </div>
                        <div class="flex-1 p-tiny">

                            <h5 class="font-medium text-sm capitalize">
                                Name: {{ principalDetails.patientName }}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">
                                Member No:{{ principalDetails.memberno }}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">
                                Member ID: {{ principalDetails.memberIDNo || `-` }}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">
                                Employer: {{ principalDetails.employer || `-` }}</h5>
                        </div>
                        <tail-stamp></tail-stamp> </div>
                </div>
                <div class="w-full overflow-visible p-1">
                    <table class="table border">
                        <tbody class="text-sm">
                            <tr>
                                <td class="font-bold p-tiny">Id</td>
                                <!-- <td class="font-bold p-tiny">Bill No</td> -->
                                <td class="font-bold p-tiny">Item</td>
                                <td class="font-bold p-tiny">Insurance</td>
                                <td class="font-bold p-tiny">Description</td>
                                <td class="font-bold p-tiny">Qty</td>
                                <td class="font-bold p-tiny">Price</td>
                                <td class="font-bold p-tiny">Tax</td>
                                <td class="font-bold p-tiny">Discount</td>
                                <td class="font-bold p-tiny">G Total</td>
                            </tr>
                            <tr v-for="item in items.invoiceItems" :key="item.invoiceDetailID">
                                <td class="p-tiny">{{item.invoiceDetailID}}</td>
                                <!-- <td class="p-tiny">{{item.billNo}}</td> -->
                                <td class="p-tiny break-words">{{item.item}}</td>
                                <td class="p-tiny break-words">{{item.insurance || `-`}}</td>
                                <td class="p-tiny break-words">{{item.description || `-`}}</td>
                                <td class="p-tiny">{{ item.qty }}</td>
                                <td class="p-tiny">{{ item.charge | numberFormat }}</td>
                                <td class="p-tiny">{{ item.tax | numberFormat }}</td>
                                <td class="p-tiny">{{ item.discount | numberFormat }}</td>
                                <td class="p-tiny">{{ item.grandTotal | numberFormat }}</td>
                            </tr>
                            <tr class="border-t-2 border-b-2 border-gray-400">
                                <td colspan="7" class="p-tiny"></td>
                                <td class="p-tiny font-medium text-sm">Total:</td>
                                <td class="p-tiny font-medium">{{ totalProforma | numberFormat }}</td>
                            </tr>
                            <tr v-show="!showinsurances" v-for="(totalsPerIns, idx) in totalsPerInsurance" :key="`__${idx}`" >
                                <td colspan="7" class="p-tiny"></td>
                                <td class="p-tiny font-medium text-sm">
                                    {{ totalsPerIns.organization }}:
                                </td>
                                <td class="p-tiny font-medium"> 
                                    {{ totalsPerIns.total | numberFormat }}</td>
                            </tr>
                            <!-- <tr v-if="otherInsurances.length">
                                <td colspan="8" class="p-tiny"></td>
                                <td class="p-tiny font-medium text-xs">
                                    Less {{ 
                                        otherInsurances.map(ins => ins.organization).join(', ') 
                                    }}:
                                </td>
                                <td class="p-tiny font-medium"> {{ otherInsuranceTotal | numberFormat }}</td>
                            </tr>
                            <tr v-if="noInsuranceTotal">
                                <th colspan="8" class="p-tiny"></th>
                                <th class="p-tiny">
                                    No Insurance:</th>
                                <th class="p-tiny">
                                    {{ noInsuranceTotal | numberFormat }}</th>
                            </tr> -->
                            <tr>
                                <td colspan="7" class="p-tiny"></td>
                                <td class="p-tiny font-medium text-sm">
                                    Tax:
                                </td>
                                <td class="p-tiny font-medium"> {{ totalTax | numberFormat }}</td>
                            </tr>
                            <tr>
                                <td colspan="7" class="p-tiny"></td>
                                <td class="p-tiny font-medium text-sm">
                                    Discount:
                                </td>
                                <td class="p-tiny font-medium"> {{ totalDiscount | numberFormat }}</td>
                            </tr>  <tr v-show="showinsurances" >
                                <td colspan="7" class="p-tiny"></td>
                                <td class="p-tiny font-medium text-sm">
                                    Less SHA:
                                </td>
                                <td class="p-tiny font-medium"> {{ items.invoiceItemDetails[0].lessNHIF | numberFormat }}</td>
                            </tr>
                            <tr v-show="showinsurances" >
                                <td colspan="7" class="p-tiny"></td>
                                <td class="p-tiny font-medium text-sm">
                                    Less COPAY:
                                </td>
                                <td class="p-tiny font-medium">  {{ items.invoiceItemDetails[0].lessCopay | numberFormat }}</td>
                            </tr>
                           
                            <tr class="border-t-2 border-b-2 border-gray-400">
                                <td colspan="7" class="p-tiny"></td>
                                <td class="p-tiny font-medium text-sm">
                                   Net Due: 
                                </td>
                                <!-- <td class="p-tiny font-medium"> 
                                    {{ (totalProforma - (totalTax + totalDiscount )) | numberFormat }}</td> -->
                                     <td class="p-tiny font-medium">  
                                        {{ selectedInsuranceTotal?selectedInsuranceTotal - (totalTax + totalDiscount )-items.invoiceItemDetails[0].lessCopay-items.invoiceItemDetails[0].lessNHIF:(totalProforma - (totalTax + totalDiscount )-items.invoiceItemDetails[0].lessCopay-items.invoiceItemDetails[0].lessNHIF) | numberFormat }}
                                    </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="w-full flex flex-wrap p-1 mt-1">
                    <!-- <div class="flex-1">
                        <h5 class="text-sm font-medium">Patient Signature: .........................</h5>
                    </div> -->
                    <div class="flex-1 text-right">
                        <h5 class="text-sm font-medium">
                            Served By:  {{ items.invoiceItems.length ? items.invoiceItems[0].userName : `-` }}</h5>
                            <!-- <h5 class="text-sm font-medium"> Signature: .........................</h5> -->
                   </div>
                </div>
                <div class="w-full p-1 text-center mt-1">
                    <h5 class="font-medium text-sm italic">{{ footerMessage.message }}</h5>
                </div>
               
            </div>
    </div>
</template>
